import styles from "./ChatSearchResultsPage.styles.scss";
import Margin from "../Margin/Margin";
import ListItem from "../list-item";
import LinkButton from "../LinkButton/LinkButton";

const ChatSearchResultsPage = ({ query = '', messages = [], loading, onNavigateToMessage, onBack }) => {
  return <div className={styles.container}>
    <Margin left={16}>
      <LinkButton leftIconName='arrow_backward' text='Voltar' onClick={onBack}/>
    </Margin>
    <Margin top={16} />
    <ListItem style={{color: '#3F51B5'}} title={`Resultados da pesquisa para ${query}`} />
    {loading && [1,2,3,4,5,6,7,8,9,10].map(() => <ListItem loading={true} />)}
    {messages.length === 0 && !loading && <Margin all={16}>
      <ListItem
        title="Nenhuma mensagem encontrada."
        subtitle="Não encontrou o que procura? Atualize a página e tente novamente ou entre em contato com o suporte." fadedSubtitle />
    </Margin>}
    {!loading && messages.map(message => <ListItem
      fadedSubtitle
      onClick={() => onNavigateToMessage(message)}
      title={message.content}
      subtitle={message.senderLabel}
    />)}
  </div>
};

export default ChatSearchResultsPage;



// WEBPACK FOOTER //
// ./components/ChatSearchResultsPage/ChatSearchResultsPage.js